import React from 'react'

export default class Timeline extends React.Component {
  render() {
    const { trip } = this.props

    return (
      <div className="timeline">
        <div className="wrap">
          <h2>Over the Years&hellip;</h2>
          <ol>
            <li>
              <strong>2001</strong>
              <span>Everlasting Tours was founded</span>
            </li>
            <li>
              <strong>2002</strong>
              <span>
                First destination - Florida. Troy &amp; Marisha met at church…
              </span>
            </li>
            <li>
              <strong>2003</strong>
              <span>…and were married 2 years later!</span>
            </li>
            <li>
              <strong>2004</strong>
              <span>Hawaii was added to the destinations</span>
            </li>
            <li>
              <strong>2005</strong>
              <span>Collaborated with top travel experts in the world</span>
            </li>
            <li>
              <strong>2009</strong>
              <span>Love Song Couples Getaway was imagined</span>
            </li>
            <li>
              <strong>2011</strong>
              <span>Maui + Love Song Couples Getaway = PERFECTION</span>
            </li>
            <li>
              <strong>2012</strong>
              <span>Love Song Couples Getaway hopped to the Big Island</span>
            </li>
            <li>
              <strong>2013</strong>
              <span>Bahamas was added to the destination line-up</span>
            </li>
            <li>
              <strong>2014</strong>
              <span>Bahamas &amp; Maui were magical!</span>
            </li>
            <li>
              <strong>2015</strong>
              <span>Kauai was released as new Hawaii destination</span>
            </li>
            <li>
              <strong>2016</strong>
              <span>The Cove Bahamas added to 2017 getaway release</span>
            </li>
            <li>
              <strong>2017</strong>
              <span>Cancun was added to the destination line-up</span>
            </li>
            <li>
              <strong>2018</strong>
              <span>LOVESONG returned to MAUI!</span>
            </li>
            <li>
              <strong>2019</strong>
              <span>
                By POPULAR demand... the 10th annual getaway will be Cancun 2020.
              </span>
            </li>
                  <li>
              <strong>2019</strong>
              <span>
                20th anniversary getaway announced to Kauai for 2021!
              </span>
            </li>
      
            <li>
              <strong>Next</strong>
              <span>&hellip;and the story continues&hellip; stay tuned!</span>
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/timeline.js